import { Component, OnInit, Input } from '@angular/core';

import { Question } from '../../question';

@Component({
  selector: 'lms-questions-list-row',
  templateUrl: './questions-list-row.component.html',
  styleUrls: ['./questions-list-row.component.scss']
})
export class QuestionsListRowComponent implements OnInit {
  @Input() question: Question;
  correctAnswer: any;

  constructor() {
    this.correctAnswer = { title: '' };
  }

  ngOnInit() {
    this.correctAnswer = this.question.answers.find((answer) => answer.isCorrect);
    if (!this.correctAnswer) {
      this.correctAnswer = { title: '' };
    }
  }
}
